import { render, staticRenderFns } from "./HomeFooter.vue?vue&type=template&id=0a5918b4"
import script from "./HomeFooter.vue?vue&type=script&lang=js"
export * from "./HomeFooter.vue?vue&type=script&lang=js"
import style0 from "./HomeFooter.vue?vue&type=style&index=0&id=0a5918b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports